import { useOutletContext } from "react-router-dom"
import { NoteTile } from "../components/NoteTile";


export function VehicleDetailsNotes(){
	const contextData = useOutletContext();
	const notes = contextData.notes.notes;
	return (
		<>
		{notes.length === 0 && <h1>No Vehicle notes recorded</h1>}
		{notes.map(note => (
			<NoteTile key={note.note_id} note={note} />
		))}
	</>
	)
}